export const translationEN = {
  translation: {
    navBar: {
      title: {
        calendar: "Choose dates",
        accommodation: "Accommodation",
        extras: "Extras",
        summary: "Summary",
        details: "Details",
        payment: "Payment",
        success: "Confirmation",
      },
    },
    cart: {
      title: {
        calendar: "Go to accommodation",
        accommodation: "Continue to extras",
        extras: "Review your booking",
        summary: "Enter your details",
        details: "Continue to payment",
        payment: "Complete booking",
      },
      selectArrivalDate: "Please select an arrival date",
      selectDepartureDate: "Please select a departure date",
      priceFrom: "From",
    },
    weekDays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          description:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "One Hub is a L-shaped pod",
            },
            { src: "see_the_top_hub.jpg", alt: "See the top Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inside the top Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "See the bottom Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Inside the bottom Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relax in your king-size bed",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Yes, you can sit up in your bed",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Play your music with Bluetooth",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Walk to the showers in our kimonos",
            },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refresh under the rain shower",
            },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            { src: "hair_&_makeup_area.jpg", alt: "Hair & makeup area" },
          ],
        },
        howManyTravellers: {
          title: "How many travellers?",
          content:
            "All our spaces come with cosy beds, mood lighting, and a touch of tech. The only question is: how do you like to stay? <br /><br />Our Hubs are perfect for solo travellers and for couples or friends who enjoy privacy & cosy vibe.<br /><br />Select 1 to 4 travellers to see the price change.",
        },
        addAnotherAccomodation: {
          title: "Add another hub",
          hub: {
            title: "Hub",
            description:
              "Private pod with a king-size bed - perfect for one or two travellers.",
          },
        },
      },
      CPH: {
        tags: ["On-site sauna"],
        hub: {
          title: "Hub",
          excerpt:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          description:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "One Hub is a L-shaped pod",
            },
            { src: "see_the_top_hub.jpg", alt: "See the top Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inside the top Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "See the bottom Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Inside the bottom Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relax in your king-size bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Walk to the showers in our kimonos",
            },
            { src: "hallway.jpg", alt: "Hallway" },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Sweat it out in our sauna",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Same size as a Hub, but split into 2 single mattresses with separate blankets and a divider. Ideal for 2 people who want their own space. Great for friends or siblings.",
          description:
            "Same size as a Hub, but split into 2 single mattresses with separate blankets and a divider. Ideal for 2 people who want their own space. Great for friends or siblings.",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "One Hub is a L-shaped pod",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Inside the top Twin Hub",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Inside the bottom Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 single mattresses with a divider",
            },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Sweat it out in our sauna",
            },
          ],
        },
        room: {
          title: "Quad Room",
          excerpt:
            "Need more space? The quad room fits up to 4 travellers. Ideal for friends or families. Comes with a private bathroom. Also suitable for disabled guests.",
          description:
            "Need more space? The quad room fits up to 4 travellers. Ideal for friends or families. Comes with a private bathroom. Also suitable for disabled guests.",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Quad room with 4 bunk beds",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Quad room with a double bed and 2 bunks",
            },
            {
              src: "private_bathroom.jpg",
              alt: "Private bathroom",
            },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refresh under the rain shower",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Sweat it out in our sauna",
            },
          ],
        },
        howManyTravellers: {
          title: "How many travellers?",
          content:
            'All our spaces come with cosy beds, mood lighting, and a touch of tech. The only question is: how do you like to stay? <ul className="list-disc p-4"><li>Travelling solo or as a couple and want privacy and a cosy vibe? → Go with a Hub.</li><li>Staying together but prefer separate beds (friends or colleagues)? → A Twin Hub is perfect.</li><li>Looking for a more spacious room with a private bathroom? → Choose a Quad room.</li></ul>Whichever you pick, you\'ll sleep well.<br />Select 1 or 2 guests to see the price change.',
        },
        addAnotherAccomodation: {
          title: "Add another accommodation",
          hub: {
            title: "Hub",
            description:
              "Private pod with a king-size bed - perfect for one or two travellers.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Private pod with two single beds and a divider - ideal for friends or siblings.",
          },
          room: {
            title: "Room",
            description:
              "Private room with bunk beds and a private bathroom - perfect for up to four travellers.",
          },
        },
      },
      RKV: {
        tags: ["On-site hot tub"],
        hub: {
          title: "Hub",
          excerpt:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          description:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "One Hub is a L-shaped pod",
            },
            { src: "see_the_top_hub.jpg", alt: "See the top Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inside the top Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "See the bottom Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Inside the bottom Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relax in your king-size bed",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Yes, you can sit up in your bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Walk to the showers in our kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Relax in our rooftop hot tub",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Same size as a Hub, but split into 2 single mattresses with separate blankets and a divider. Ideal for 2 people who want their own space. Great for friends or siblings.",
          description:
            "Same size as a Hub, but split into 2 single mattresses with separate blankets and a divider. Ideal for 2 people who want their own space. Great for friends or siblings.",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "One Hub is a L-shaped pod",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Inside the top Twin Hub",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Inside the bottom Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 single mattresses with a divider",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Walk to the showers in our kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Relax in our rooftop hot tub",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          excerpt: "Private pod with a king-size bed and a big screen TV.",
          description:
            "This tiny room for up to 2 travellers features a king-size bed and a big screen TV. Great for binge-watching from bed.",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relax in your king-size bed",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "Large tv for your favourite shows",
            },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Relax in our rooftop hot tub",
            },
          ],
        },
        howManyTravellers: {
          title: "How many travellers?",
          content:
            'All our spaces come with cosy beds, mood lighting, and a touch of tech. The only question is: how do you like to stay? <ul className="list-disc p-4"><li>Travelling solo or as a couple and want privacy and a cosy vibe? → Go with a Hub.</li><li>Staying together but prefer separate beds (friends or colleagues)? → A Twin Hub is perfect.</li><li>Looking for a more traditional room with a large TV (shared bathroom)? → Choose a Movie Hub.</li></ul>Whichever you pick, you\'ll sleep well.<br />Select 1 or 2 guests to see the price change.',
        },
        addAnotherAccomodation: {
          title: "Add another accommodation",
          hub: {
            title: "Hub",
            description:
              "Private pod with a king-size bed - perfect for one or two travellers.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Private pod with 2 single beds and a divider - ideal for friends or siblings.",
          },
          movieHub: {
            title: "Movie Hub",
            description:
              "Compact private room with a king-size bed and a TV - perfect for up to two travellers.",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          description:
            "Your own private pod for up to 2 travellers with a king-size bed. Perfect for solo travellers, friends or couples who like it cosy and connected.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "One Hub is a L-shaped pod",
            },
            { src: "see_the_top_hub.jpg", alt: "See the top Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inside the top Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "See the bottom Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Inside the bottom Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relax in your king-size bed",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Yes, you can sit up in your bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Walk to the showers in our kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refresh under the rain shower",
            },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Same size as a Hub, but split into 2 single mattresses with separate blankets and a divider. Ideal for 2 people who want their own space. Great for friends or siblings.",
          description:
            "Same size as a Hub, but split into 2 single mattresses with separate blankets and a divider. Ideal for 2 people who want their own space. Great for friends or siblings.",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "One Hub is a L-shaped pod",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Inside the bottom Twin Hub",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Relax in your king-size bed",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Walk to the showers in our kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Women's bathroom" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refresh under the rain shower",
            },
            { src: "men_s_bathroom.jpg", alt: "Men's bathroom" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Free Rituals amenities",
            },
          ],
        },
        howManyTravellers: {
          title: "How many travellers?",
          content:
            'All our spaces come with cosy beds, mood lighting, and a touch of tech. The only question is: how do you like to stay? <ul className="list-disc p-4"><li>Travelling solo or as a couple and want privacy and a cosy vibe? → Go with a Hub.</li><li>Staying together but prefer separate beds (friends or colleagues)? → A Twin Hub is perfect.</li></ul>Whichever you pick, you\'ll sleep well.<br />Select 1 or 2 guests to see the price change.',
        },
        addAnotherAccomodation: {
          title: "Add another accommodation",
          hub: {
            title: "Hub",
            description:
              "Private pod with a king-size bed - perfect for one or two travellers.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Private pod with two single beds and a divider - ideal for friends or siblings.",
          },
        },
      },
      tags: {
        hub: [
          "Private pod for 1-2 people",
          "1 king-size bed ",
          "Shared bathrooms",
          "Rituals amenities",
          "Towels",
          "Kimonos",
        ],
        twinHub: [
          "Private pod for 2 people",
          "2 single mattresses with a divider",
          "Shared bathrooms",
          "Rituals amenities",
          "Towels",
          "Kimonos",
        ],
        room: [
          "20m² room for 1-4 people",
          "4 bunks or 2 bunks & double bed",
          "Private bathroom",
          "Rituals amenities",
          "Towels",
          "Kimonos",
          "Wheelchair access",
        ],
        movieHub: [
          "Private pod for 1-2 people",
          "1 king-size bed ",
          "Shared bathrooms",
          "Rituals amenities",
          "Towels",
          "Kimonos",
          "TV",
        ],
      },
      faq: {
        hub: [
          {
            q: "Top or bottom Hub? Can I choose?",
            a: "Yep. A Hub is your own private sleeping pod, shaped like an L and made for 2 people. Hubs come stacked in pairs: one on top and one on the bottom. Upon check‑in, you decide whether you'd rather climb up or dive in.",
          },
          {
            q: "Tell me more about this Hub.",
            a: "Your 6m² Hub is equipped with smart storage space, power plugs and WiFi. The beds are made for you. You can set the Hub lights to match your mood with the CityHub app. Complete with Bluetooth music streaming.",
          },
          {
            q: "Is there air conditioning in the Hub?",
            a: "Yes, your Hub is connected to a central climate control system set at the most comfortable level for the average traveller.",
          },
          {
            q: "How are the bathrooms?",
            a: "Pretty luxurious. Shared but separate for men and women, they come with rain showers and complimentary amenities. We keep them super clean, all day, every day.",
          },
          {
            q: "Do you have towels? What else don't I have to bring?",
            a: "We have it all here for you. Towels, Rituals soap, shampoo, hairdryers and, yes, we have an iron. Do you know we also have special CityHub kimonos? Quite convenient to walk to the showers. Bring your own flip flops, though.",
          },
          {
            q: "Can I come with kids?",
            a: "We love kids, we really do. Unfortunately, though, our shared facilities are not suitable for babies or really young children below 6 years. Note that one Hub fits 2 people max. That includes children.",
          },
        ],
        twinHub: [
          {
            q: "Top or bottom Hub? Can I choose?",
            a: "Yep. A Hub is your own private sleeping pod, shaped like an L and made for 2 people. Hubs come stacked in pairs: one on top and one on the bottom. Upon check‑in, you decide whether you'd rather climb up or dive in.",
          },
          {
            q: "Tell me more about this Hub.",
            a: "Your 6m² Hub is equipped with smart storage space, power plugs and WiFi. The beds are made for you. You can set the Hub lights to match your mood with the CityHub app. Complete with Bluetooth music streaming.",
          },
          {
            q: "Is there air conditioning in the Hub?",
            a: "Yes, your Hub is connected to a central climate control system set at the most comfortable level for the average traveller.",
          },
          {
            q: "How are the bathrooms?",
            a: "Pretty luxurious. Shared but separate for men and women, they come with rain showers and complimentary amenities. We keep them super clean, all day, every day.",
          },
          {
            q: "Do you have towels? What else don't I have to bring?",
            a: "We have it all here for you. Towels, Rituals soap, shampoo, hairdryers and, yes, we have an iron. Do you know we also have special CityHub kimonos? Quite convenient to walk to the showers. Bring your own flip flops, though.",
          },
          {
            q: "Can I come with kids?",
            a: "We love kids, we really do. Unfortunately, though, our shared facilities are not suitable for babies or really young children below 6 years. Note that one Hub fits 2 people max. That includes children.",
          },
        ],
        room: [
          {
            q: "Tell me more about this Quad room.",
            a: "Your Quad Room comes with a private bathroom and is equipped with power plugs and WiFi. The beds are made for you. You can set the room lights to match your mood with the CityHub app. Complete with Bluetooth music streaming.",
          },
          {
            q: "Is there air conditioning in the Quad room?",
            a: "Yes, your Quad room is connected to a central climate control system set at the most comfortable level for the average traveller.",
          },
          {
            q: "Do you have towels? What else don't I have to bring?",
            a: "We have it all here for you. Towels, Rituals soap, shampoo, hairdryers and, yes, we have an iron. Do you know we also have special CityHub kimonos? Quite convenient to walk to the showers. Bring your own flip flops, though.",
          },
          {
            q: "Can I come with kids?",
            a: "We love kids, we really do. Unfortunately, though, our shared facilities are not suitable for babies or really young children below 6 years. Note that one Quad Room fits 4 people max. That includes children.",
          },
        ],
        movieHub: [
          {
            q: "Tell me more about this Movie Hub.",
            a: "Your Movie Hub is equipped with smart storage space, power plugs, WiFi, and a big screen TV. The beds are made for you. You can set the lights to match your mood with the CityHub app. Complete with Bluetooth music streaming.",
          },
          {
            q: "s there air conditioning in the Movie Hub?",
            a: "Yes, your Movie Hub is connected to a central climate control system set at the most comfortable level for the average traveller.",
          },
          {
            q: "How are the bathrooms?",
            a: "Pretty luxurious. Shared but separate for men and women, they come with rain showers and complimentary amenities. We keep them super clean, all day, every day.",
          },
          {
            q: "Do you have towels? What else don't I have to bring?",
            a: "We have it all here for you. Towels, Rituals soap, shampoo, hairdryers and, yes, we have an iron. Do you know we also have special CityHub kimonos? Quite convenient to walk to the showers. Bring your own flip flops, though.",
          },
          {
            q: "Can I come with kids?",
            a: "We love kids, we really do. Unfortunately, though, our shared facilities are not suitable for babies or really young children below 6 years. Note that one Hub fits 2 people max. That includes children.",
          },
        ],
      },
    },
    modal: {
      selectHotel: {
        title: "Select city",
        button: {
          label: "Select city",
        },
      },
      selectCulture: {
        title: "Language & currency",
        button: {
          label: "Save changes",
        },
      },
      uspBar: {
        title: "Lowest Price Guaranteed",
        content:
          "We guarantee that if you are booking via this website, you will always get the best price possible.",
      },
    },
    component: {
      uspBar: {
        title: "Lowest Price Guaranteed",
      },
    },
    scenes: {
      traveller_one: "traveller",
      traveller_other: "travellers",
      night_one: "night",
      night_other: "nights",
      selectHotel: {
        chooseCity: "Let's book together, choose your city",
      },
      accommodation: {
        pricePerNight: "Price per night",
        pricePerNightInclVat: "Price per night (incl. vat)",
        remove: "Remove",
        directBookingDiscount: "Direct Booking Discount",
        notAvailable: "not available",
        unavailable: "Unavailable",
        noMoreRoomsAvailable: "Book now · last Hub",
        addAnotherRoom: "Add another room",
        addAnotherHub: "Add another Hub",
        howManyTravellers: "How many travellers?",
        questions: "FAQs",
        moreTags_one: "more tag",
        moreTags_other: "more tags",
        more_info: "more info",
        show_more: "More information",
        show_less: "Less information",
        selected: "selected",
        select: "Select",
        price_from: "From",
        not_available: "Not available for this date",
        add: "Add",
        next: "Next",
        book_now: "Book now",
        how_many_rooms: "How many {{name}}s?",
        number_of_rooms: "Number of {{name}}s?",
        room_category_rates: {
          title: "Rates",
          select_rate: "Select a rate",
          total: "Total",
        },
      },
      calendar: {
        startNotice: "{{hotelName}} opens its doors in {{startDate}}",
      },
      extras: {
        perPersonPerNight: "per person, per night",
        add: "Add",
        remove: "Remove",
        moreInfo: "More info",
      },
      summary: {
        perNight: "/ night",
        checkIn: "CHECK-IN",
        checkOut: "CHECK-OUT",
        rate: "Rate:",
        discount: "Discount:",
        from: "From",
        before: "Before",
        total: "Total",
        incCityTax: "City tax",
        incVat: "Incl. Vat",
        incVatRooms: "Incl. VAT rooms",
        incVatProducts: "Incl. VAT products",
        directBookingDiscount: "Direct Booking Discount",
        voucher: "Voucher",
        addVoucher: "Add a voucher",
        voucherInvalid: "This voucher code is not correct",
        voucherNotApplicable: "This voucher is not valid for the selected rate",
      },
      details: {
        firstName: "First name",
        firstNameRequired: "First name is required",
        lastName: "Last name",
        lastNameRequired: "Last name is required",
        email: "Email address",
        emailRequired: "Email address is required",
        emailInvalid:
          "Email is required and should contain a @ and at least one dot",
        phoneMin: "Phone number should be at least 9 numbers",
        phoneInvalid: "Phone number should be numeric",
        countryRequired: "Country is a required field",
        phone: "Phone number",
        country: "Country",
        selectCountry: "Select your country",
        specialRequests: "Special requests",
        terms:
          "I agree to <firstLink>Property T&C</firstLink> and <secondLink>Property Privacy Policy.</secondLink>",
        marketingEmails: "I'd like to occasionally receive marketing updates.",
        createReservation: "Create reservation",
        finishPaymentAtKiosk: "Finish your payment at our kiosk.",
        creatingReservation: "Creating your reservation...",
        reservationCreated: "Reservation created!",
        somethingWentWrong: "Something went wrong, please try again.",
      },
      payment: {
        paymentMethods: "Payment methods",
        paymentMethodsDescription:
          "Just one last step — complete your payment safely below. We use encrypted payment methods to protect your information at every step. After your payment is confirmed, you'll receive your confirmation email.",
        authorizeCreditCard: "Authorize your creditcard",
        cardChargeInfo:
          "Your card will be charged 48 hours prior to arrival day",
        securedWithMews: "Secured with Mews Payments via PCI Proxy",
        payWithCreditCard: "Pay with credit card",
        payDirectly: "Pay directly",
        onlyVisaAndMastercardSupported:
          "Only Visa and MasterCard are supported",
        nameOnCreditCard: "Name on credit card",
        cardNumber: "Card number",
        expirationDate: "Expiration date",
        expirationDateRequired: "Expiration date is required",
        yearCanNotBeInThePast: "Year can not be in the past",
        yearCanNotBeMoreThan5YearsInTheFuture:
          "Year can not be more than 5 years in the future",
        monthCanNotBeInThePast: "Month can not be in the past",
        monthCanNotBeBiggerThan12: "Month can not be bigger than 12",
        shouldBeAMonthAndAYear: "Should be a month and a year MM/YYYY",
        validateCard: "Validate card",
        createReservation: "Create reservation",
        nameIsRequired: "Name is required",
        cardNumberIsRequired: "Card number is required",
        invalidCardNumber: "Invalid card number",
        cvcIsRequired: "CVC is required",
        invalidCvc: "Invalid CVC",
        somethingWentWrong: "Something went wrong. Please try again later.",
        somethingWentWrong4501:
          "Something went wrong (4501). Please try again later.",
        creatingReservation: "Creating your reservation...",
        reservationCreated: "Reservation created!",
        finishPayment: "Finishing your payment...",
        creditcardNotAuthorizable: "Creditcard not authorizable",
      },
      success: {
        bookingConfirmed: "Booking confirmed!",
        bookingConfirmedDescription:
          "Your stay at {{hotelName}} is all set. <br/>Check-in from 15:00. See you soon 👋",
        startChatting: "Start chatting",
        viewBookingDetails: "View booking details",
        bookingDetails: "Booking Details",
        whatsNext: "What's next?",
        connectWithHost:
          "Connect with your CityHost, Your personal 24/7 contact for tips, directions, and local secrets.",
        online: "ONLINE",
      },
      pageNotFound: {
        message: "Whoops! <br />We can't find the page you're looking for.",
        linkText: "Choose your hotel to get started",
      },
      redirectHotel: {
        message: "Loading hotel configuration...",
      },
      redirectPayment: {
        error4602: "[error" + ":4602] No reservation found",
        noPaymentsFound: "No payments found",
        paymentSuccessful: "Payment successful",
        paymentFailed: "Payment failed",
        returningToSite: "Returning to the site...",
        authorizationPending: "Authorization pending",
        authorizationPendingMessage:
          "Your reservation is created but the authorization is still pending.<br /><br />Click here to authorizeyour card.",
      },
    },
    form: {
      language: {
        label: "Language",
        placeholder: "Select language",
        options: {
          "en-US": "English",
          "nl-NL": "Dutch",
        },
        validation: { required: "Language is a required field" },
      },
      currency: {
        label: "Currency",
        placeholder: "Select currency",
        options: {
          EUR: "Euro (€)",
          USD: "US Dollar ($)",
          GBP: "British Pound (£)",
          CAD: "Canadian Dollar (C$)",
          DKK: "Danish Krone (DKK)",
          ISK: "Icelandic Krona (ISK)",
        },
        validation: { required: "Currency is a required field" },
      },
    },
  },
};
